module.exports = __webpack_public_path__ + "static/media/Vela - DK Grey.40298de3.jpg";